import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'ha/i18n';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';
import { normalizeApiV2Errors } from 'ha/utils/reduxForm';
import dayjs from 'dayjs';
import { setInStorage } from 'ha/utils/storage';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import { loginRequest, registerRequest } from './actions';
import { getIsLoading } from './selectors';

const AuthLogic = ({ children }) => {
  const { T } = useIntl();
  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoading);
  const notificationLang = useSelector(getCurrentLanguageCode);

  const onLogin = React.useCallback(
    nextUrl => fields =>
      dispatch(loginRequest(fields, nextUrl))
        .then(() => {
          dispatch(NavBarActions.hideModal());
        })
        .catch(err => Promise.reject(normalizeApiV2Errors(T, err))),
    [],
  );

  const onRegister = React.useCallback(
    nextUrl => fields =>
      dispatch(registerRequest({ ...fields, notificationLang }, nextUrl))
        .then(() => {
          setInStorage('verifyEmailDialogLastShown', dayjs().valueOf());
          dispatch(NavBarActions.hideModal());
        })
        .catch(err => Promise.reject(normalizeApiV2Errors(T, err))),
    [],
  );

  return children(onLogin, onRegister, isLoading);
};

export default AuthLogic;
